import React, { useCallback } from 'react';
import type { FC } from 'react';
import { TextInput } from '@wix/cli-ui-kit';
import { useTranslation } from '@wix/cli-i18n';
import { useWixCliAppBi } from '../../../bi/index.js';

interface ReleaseCommentProps {
  onEntered: (comment: string) => void;
}

export const ReleaseComment: FC<ReleaseCommentProps> = (props) => {
  const { onEntered } = props;

  const { t } = useTranslation();
  const bi = useWixCliAppBi();

  const validate = useCallback(
    (value: string) => {
      if (value && value.length > 250) {
        return t('release_command.release_comment_requirement');
      }
      return true;
    },
    [t]
  );

  return (
    <TextInput
      label={t('release_command.enter_release_comment')}
      onSubmit={(answer) => {
        bi.cliFlowStepAnswered({
          question: t('release_command.enter_release_comment'),
          questionKey: 'release_command.enter_release_comment',
          answer,
        });
        onEntered(answer);
      }}
      validate={validate}
    />
  );
};
